import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const OrgAccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${theme.colors.purple_2};
  border-radius: 8px;
  background-color: ${theme.colors.white};
  padding: 20px;

  & .chips-container {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 8px;
  }

  & .toggle-container {
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    padding: 0px 0px 20px 0px;
    gap: 8px;
  }

  & .accordion-list {
    display: flex;
    flex-direction: column;
    height: 300px;
    overflow-y: auto;
    gap: 12px;
    transition: visibility 0.4s ease-in;
    scrollbar-gutter: stable;
  }
`;

export const OrgAccordionContent = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.SM}px) {
    grid-template-columns: 1fr;
  }
`;

export const OrgAccordionOption = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 12px;
  align-items: center;
  justify-content: start;
  background-color: ${theme.colors.white};
  border-radius: 8px;
`;
